import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
    ClientField,
    CreateClientFieldRequest,
    UpdateClientFieldRequest,
} from '../../types/ClientField';
import {
    requestClientFields,
    requestCreateClientField,
    requestDeleteClientField,
    requestUpdateClientField,
} from '../clientFields/clientFields';

export function useClientFields() {
    return useQuery<ClientField[], Error>({
        queryKey: ['clientFields'],
        queryFn: async ({ signal }) => (await requestClientFields(signal)).data,
    });
}

export function useCreateClientField() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (field: CreateClientFieldRequest) =>
            (await requestCreateClientField(field)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['clientFields'] });
        },
    });
}

export function useUpdateClientField() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (field: UpdateClientFieldRequest) =>
            (await requestUpdateClientField(field)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['clientFields'] });
        },
    });
}

export function useDeleteClientField() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (fieldId: number) => (await requestDeleteClientField(fieldId)).data,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['clientFields'] });
        },
    });
}
